module.exports = __webpack_public_path__ + "static/media/futa.9ca785a3.jpg";